import { render, staticRenderFns } from "./ProductsContainer.vue?vue&type=template&id=3ed6144f&scoped=true"
import script from "./ProductsContainer.vue?vue&type=script&lang=ts"
export * from "./ProductsContainer.vue?vue&type=script&lang=ts"
import style0 from "./ProductsContainer.vue?vue&type=style&index=0&id=3ed6144f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed6144f",
  null
  
)

export default component.exports